import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import SectionActions from './SectionActions';
import PrintHeader from './PrintHeader';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';
import { BarChart3, TrendingUp, Users, Clock, Building2, Loader2, Download } from 'lucide-react';

const COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6'];

const Reportistica = () => {
  const [stats, setStats] = useState(null);
  const [timbrature, setTimbrature] = useState([]);
  const [loading, setLoading] = useState(true);
  const pageRef = useRef(null);

  useEffect(() => {
    const load = async () => {
      try {
        const [s, t] = await Promise.all([
          api.getStats(),
          api.getTimbrature(),
        ]);
        setStats(s); setTimbrature(t);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  if (loading) return <div className="page-container"><div className="loading-center"><Loader2 size={32} className="spin" /></div></div>;

  const onSite = stats?.onSite || 0;
  const offSite = (stats?.totalOperai || 0) - onSite;
  const pieData = [
    { name: 'Presenti', value: onSite },
    { name: 'Assenti', value: offSite },
  ];

  // Group timbrature by hour for chart
  const hourData = Array.from({ length: 12 }, (_, i) => ({ hour: `${i + 6}:00`, count: 0 }));
  timbrature.forEach(t => {
    const h = new Date(t.timestamp).getHours();
    const idx = h - 6;
    if (idx >= 0 && idx < 12) hourData[idx].count++;
  });

  return (
    <div className="page-container" ref={pageRef}>
      <PrintHeader title="Reportistica" subtitle="Analytics e report di cantiere" />
      <div className="page-header">
        <div className="header-left">
          <h1 className="page-title">Reportistica</h1>
          <p className="page-subtitle">Analytics e report di cantiere</p>
        </div>
        <div className="header-right">
          <SectionActions sectionTitle="Reportistica" contentRef={pageRef} />
        </div>
      </div>

      <div className="report-kpis">
        <div className="kpi-card"><Clock size={20} color="#3b82f6" /><span className="kpi-value">{timbrature.length}</span><span className="kpi-label">Timbrature Oggi</span></div>
        <div className="kpi-card"><Users size={20} color="#22c55e" /><span className="kpi-value">{stats?.onSite || 0}</span><span className="kpi-label">Operai Presenti</span></div>
        <div className="kpi-card"><Building2 size={20} color="#f59e0b" /><span className="kpi-value">{stats?.cantieriAttivi || 0}</span><span className="kpi-label">Cantieri Attivi</span></div>
        <div className="kpi-card"><TrendingUp size={20} color="#8b5cf6" /><span className="kpi-value">{stats?.checklistDone || 0}/{stats?.checklistTotal || 0}</span><span className="kpi-label">Sicurezza</span></div>
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <h3 className="chart-title">Timbrature per Ora (Oggi)</h3>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={hourData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="hour" tick={{ fontSize: 11, fill: '#9ca3af' }} />
                <YAxis tick={{ fontSize: 12, fill: '#9ca3af' }} allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="count" fill="#3b82f6" radius={[6, 6, 0, 0]} name="Timbrature" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="chart-card">
          <h3 className="chart-title">Stato Operai</h3>
          <div className="chart-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={60} outerRadius={100} paddingAngle={4} dataKey="value">
                  {pieData.map((entry, index) => <Cell key={index} fill={COLORS[index]} />)}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="pie-legend">
            <span className="pie-item"><span className="pie-dot" style={{ background: COLORS[0] }} /> Presenti ({onSite})</span>
            <span className="pie-item"><span className="pie-dot" style={{ background: COLORS[1] }} /> Assenti ({offSite})</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reportistica;
